import { myValueFormatter, myValueFormatter_quantity, rateFormatter } from "./commonFunctions"
import ContractLinkComponent from "../components/ContractLink";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";

function is_number(char: any) {
  
    return !isNaN(parseInt(char));
  
}

var myValueFormatter_d = (p: any) => {
  let is_n = is_number(p.value);

  if (is_n) {
    return formatNumber_d.format(Math.ceil(p.value));
  }
};

const formatNumber_d = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const SLQuoteDashboardDefs = [
    {
      headerName: 'Ticker',
      field: 'ticker',
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 80,
      maxWidth: 100,
      suppressSizeToFit: false,
      sortable: true,
      filter: 'agMultiColumnFilter',
      cellRenderer: TickerHyperLinkComponent,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Cusip',
      field: 'cusip',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 85,
      maxWidth: 130,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Contract Id',
      field: 'contract_id',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      lockPinned: true,
      cellClass: 'lock-pinned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 90,
      maxWidth: 130,
      suppressSizeToFit: false,
      sortable: true,
      cellRenderer: ContractLinkComponent,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'B/L',
      field: 'bl',
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 60,
      maxWidth: 70,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Cpty Id',
      field: 'cpty_id',
      filter: 'agMultiColumnFilter',
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 75,
      maxWidth: 80,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Cpty Name',
      field: 'cpty_name',
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 90,
      maxWidth: 120,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Quantity',
      field: 'quantity',
      type: 'rightAligned',
      valueFormatter: myValueFormatter_quantity,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.quantity < 0) {
          return {
            display: 'flex',
            alignItems: 'center',
            border: '2px solid red',
            justifyContent: 'flex-end'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }
        }
      },
      minWidth: 100,
      maxWidth: 130,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'Rate',
      field: 'rate',
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 90,
      maxWidth: 100,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      },
      valueFormatter: rateFormatter
    },
  
    {
      headerName: 'Value',
      field: 'colvalue',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      valueFormatter: myValueFormatter,
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 120,
      maxWidth: 180,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: "Daily Accruals",
      field: "daily_accrual",
      floatingFilter: false,
      editable: false,
      filter: "agMultiColumnFilter",
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: "rightAligned",
      valueFormatter: myValueFormatter_d,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
      minWidth: 110,
      maxWidth: 140,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: "IsBuyIn",
      field: "is_buyin",
      floatingFilter: false,
      editable: false,
      filter: "agSetColumnFilter",
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
        }
      },
      minWidth: 70,
      maxWidth: 100,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: "IsRecall",
      field: "is_recall",
      floatingFilter: false,
      editable: false,
      filter: "agSetColumnFilter",
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
        }
      },
      minWidth: 70,
      maxWidth: 100,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  ]

  export const SLQuoteDashboardSupplyDefs = [
    {
      headerName: 'Lender',
      field: 'lender',
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 80,
      maxWidth: 150,
      suppressSizeToFit: false,
      sortable: true,
      filter: 'agMultiColumnFilter',
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    {
      headerName: 'Rate',
      field: 'rate',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
      minWidth: 85,
      maxWidth: 130,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      },
      valueFormatter: rateFormatter
    },
    
    {
      headerName: 'Quantity',
      field: 'qty',
      type: 'rightAligned',
      valueFormatter: myValueFormatter_quantity,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.quantity < 0) {
          return {
            display: 'flex',
            alignItems: 'center',
            border: '2px solid red',
            justifyContent: 'flex-end'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }
        }
      },
      minWidth: 100,
      //maxWidth: 230,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'Price',
      field: 'price',
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      editable: false,
      valueFormatter: myValueFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 90,
      maxWidth: 150,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'Value',
      field: 'value',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      valueFormatter: myValueFormatter,
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 120,
      //maxWidth: 250,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: "Type",
      field: "receive_type",
      floatingFilter: false,
      editable: false,
   //   filter: "agNumberColumnFilter",
      filter: "agMultiColumnFilter",
      floatingFilterComponentParams: { suppressFilterButton: true },
      valueFormatter: myValueFormatter_d,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      minWidth: 110,
      maxWidth: 140,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    },
    
  ]